import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomItemStagesDto } from './bom-item-stages.dto';

@Injectable({ providedIn: 'root' })
export class BomItemStagesProvider {
  constructor(private http: HttpClient) {}

  getStages(bomItemId: number): Observable<BomItemStagesDto[]> {
    const url = `/api/bom/${bomItemId}/stages`;
    return this.http.get<BomItemStagesDto[]>(url);
  }
}
